module.exports = __webpack_public_path__ + "img/report01.b4aa8658.png";